﻿// Open Productivity - Smartform version 1.61
(function ($) {
    "use strict";

    // Add any neccessary contructor parameters in side the function () below. Example function (otherControl), this will
    $.fn.smartform = function (options) { // <-- Constructor method
        var $form = $(this);
        if (!options) options = {};

        if (!$.fn.Alert) {
            $.fn.Alert = function (text, thenFunc) {
                alert(text);
                if (thenFunc) thenFunc();
            };
        }

        if (!$.fn.Confirm) {
            $.fn.Confirm = function (text, okFunc, cancelFunc) {
                if (confirm(text)) {
                    if (okFunc) okFunc();
                } else {
                    if (cancelFunc) cancelFunc();
                }
            };
        }

        function exists(el) {
            return jQuery.contains(document, el);
        }

        function handlePopover(event) {
            if ($form.Connected && (!$form.length || !exists($form[0]))) {
                console.log("Smartform.JS: " + "Disconnecting mousedown event for Form not in DOM");
                return;
            } else {
                $(document).one("mousedown", handlePopover);
            }

            if (!$(event.target).is(".popover *")) { // Prevent closing a popover when clicking inside it
                $form.find("[data-func=\"popoverbar\"]").trigger("depopover");
            }
        }

        $(document).one("mousedown", handlePopover);

        function supportsPlainText() {
            var d = document.createElement("div");
            try {
                d.contentEditable = "PLAINtext-onLY";
            } catch (e) {
                return false;
            }
            return d.contentEditable == "plaintext-only";
        }

        $form.SupportContEditPlainText = supportsPlainText();

        $form.ThumbUrlPrefix = options.ThumbUrlPrefix ? options.ThumbUrlPrefix : "";
        $form.DownloadUrlPrefix = options.DownloadUrlPrefix ? options.DownloadUrlPrefix : "";
        $form.UndoHistory = new Array();
        $form.MaxUndoHistoryActions = typeof options.MaxUndoHistoryActions !== "undefined" ? options.MaxUndoHistoryActions : 30;
        $form.AutoAddMissingOptions = typeof options.AutoAddMissingOptions !== "undefined" ? options.AutoAddMissingOptions : true;
        $form.LookUps = []; // Stores premade field index lookups for all arrays
        $form.Containment = typeof options.Containment !== "undefined" ? options.Containment : "document";
        $form.DisableConfirmDelete = options.DisableConfirmDelete;

        // Transactions fields
        $form.PendingOperations = [];
        $form.LinkCache = [];
        $form.Connected = true;
        $form.$placeholder = null; // Used for detach and reattach during update transactions
        $form.Writing = false;

        // Prepare Lookup index for arrays by tagging them, must be done before source templates are copied to initialized arrays
        $form.PrepareArrayLookUps = function () {
            $form.find("[data-array=\"\"]").each(function () {
                $(this).removeAttr("data-array");
            });
            $form.TagLookUp($form);
            $form.find("[data-array]").each(function () {
                var $t = $(this);
                var items = $t.children();
                $.each(items, function () {
                    $form.TagLookUp($(this));
                });
            });
            $form.Log("Pretagged " + $form.LookUps.length + " arrays in markup");
        }

        $form.TagLookUp = function ($v) {
            //var $v = $(this);
            $v.attr("data-lookup-index", $form.LookUps.length);
            $form.LookUps.push(null);
        };

        $form.GetNotes = function () {
            var notes = [];

            $.each($form.find(".docnote"), function (i, note) {
                var p = $(note);
                notes[i] = {
                    text: p.text(),
                    left: p.css("left"),
                    top: p.css("top")
                };

                $.each(note.attributes, function () {
                    if (this.specified && (this.name.indexOf("data-") == 0)) notes[i][this.name] = this.value;
                });

            });

            return notes;
        };
        $form.IsTouchDevice = "ontouchstart" in document.documentElement;
        $form.HasMouse = false;
        $form.on("mousemove", function () {
            $form.HasMouse = true;
            $form.off("mousemove");
        });
        $form.on("modified", function () {
            if (!$form.Writing) {
                $form.LinkCache = [];
                $form.Log("Reset LINK cache");
            }
        });
        $form.AddNotes = function (notes) {
            $.each(notes, function (i, note) {
                $form.AddDocNote(note);
            });
        };
        $form.CloneItem = function (item) {
            var $p = item.parent(); // Get reference to array element

            var $copy = $p.data("data-template"); // Fetch stored template
            var variant = item.attr("data-variant"); // Read variant type if any
            if (variant != null) {
                var oselect = "[data-variant=\"" + variant + "\"]";
                $copy = $copy.find(oselect).clone();
            } else {
                $copy = $copy.children().first().clone();
            }
            $copy.hide();
            item.after($copy); // Add new cloned copy just after source item in array element

            $copy.HookActions($form);

            $form.UpdateCalculations();
            // Copy values
            var values = $form.Read(item);
            $form.WriteSection($copy, values);
            $copy.find("[data-func=\"guid\"]").val(guid()); // Make new GUIDs on copy

            // Show cloned item
            var fx = "drop";
            if ($copy.is("tr")) fx = "fade";

            $copy.show(fx, {}, 100);
            return $copy;
        };
        $form.RemoveItem = function (item, noconfirm) {
            var clicked = $(item);
            var row = clicked.is("[data-array] > *") ? clicked : clicked.closest("[data-array] > *");
            while (row.is("[data-noarray]")) {
                var p = row.parent();
                row = p.closest("[data-array] > *");
            }

            var empty = true;
            row.find(":input").each(function () {
                if ($(this).val() !== "") empty = false;
            });
            row.find("[data-name][data-func=input]").each(function () {
                if ($(this).html() !== "") empty = false;
            });

            var fx = "drop";
            if (row.is("tr")) fx = "fade";
            var $arr = row.parent();
            var index = $arr.children(":not([data-noarray])").index(row);

            if (empty) {
                $form.LogUndoState("Slettet rad i liste");
                row.hide(fx, {}, 100, function () {
                    var item = $(this);
                    item.find("[data-array] > *").trigger("removing", [index, $arr, row]);
                    item.trigger("removing", [index, $arr, row]);
                    item.remove();
                    $form.UpdateCalculations();
                    $arr.trigger("removed", [index, $arr, row]);
                });
                return false;
            }
            var deleteItem = function () {
                $form.LogUndoState("Slettet rad i liste");
                row.hide(fx, {}, 100, function () {
                    var item = $(this);
                    item.find("[data-array] > *").trigger("removing", [index, $arr, row]);
                    item.trigger("removing", [index, $arr, row]);
                    item.remove();
                    $form.UpdateCalculations();
                    $arr.trigger("removed", [index, $arr, row]);
                });
            };

            if (!$form.DisableConfirmDelete && !noconfirm) {
                $.fn.Confirm($.fn.SmartformTexts.Actions.ConfirmDeleteRow, deleteItem);
            } else deleteItem();
        };
        $form.on("keyup keypress change input", function () {
            $form.UpdateCalculations();
        });

        var updateGuiTimer = null;
        $form.UpdateGuiTimerDelayMs = 250;
        $form.UpdateCalculations = function () {
            if (typeof UpdateCalculations == "function") {
                UpdateCalculations(); // TODO: Phase this option out, use events instead
            }
            $form.trigger("calcupdate");

            if (updateGuiTimer != null) clearTimeout(updateGuiTimer);
            updateGuiTimer = setTimeout($form.UpdateFormGUI, $form.UpdateGuiTimerDelayMs);
        };
        $form.UpdateFormGUI = function () {
            if (typeof UpdateFormGUI == "function") {
                UpdateFormGUI();
            }
            $form.trigger("guiupdate", [$form]);
            $form.trigger("modified", [$form]);
        }

        // Logs state to undo history
        $form.LogUndoState = function (title, currentState) {
            if (currentState == null) currentState = $form.Read();
            $form.UndoHistory.push({ title: title, state: currentState });
            if ($form.UndoHistory.length > $form.MaxUndoHistoryActions)
                $form.UndoHistory.shift(); // Remove oldest undo history item
        }

        $form.PerformUndo = function () {
            var y = $(window).scrollTop();
            if ($form.UndoHistory.length <= 0) return false; // No undo actions to perform
            var restoreState = $form.UndoHistory.pop(); // Get and remove last state
            $form.Write({});
            $form.Write(restoreState.state);
            $(window).scrollTop(y);
            return true;
        }

        $form.PerformRedo = function () {
            $.fn.Alert("Missing implementation!"); // TODO:
            return true;
        }

        $form.AddedDocItem = function () {
            if (typeof AddedDocItem == "function") {
                AddedDocItem(); // TODO: Phase this option out, use events instead
            }
            $form.trigger("adddocitem");
        };

        $form.FocusElement = function ($t) {
            var c = $t.find(":input,[contenteditable]").not(".skipautofocus,.skipautofocus *,[type=hidden],:hidden").first();
            c.select().focus();
            return c;
        };

        $form.LoadDocCompleted = function () {
            if (typeof LoadDocCompleted == "function") {
                LoadDocCompleted(); // TODO: Phase this option out, use events instead
            }
            $form.trigger("loadcomplete");
        };

        $form.IsPieceOfShitBrowser = function () {
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf("MSIE ");
            var edge = ua.indexOf(" Edge\/");
            var trident = ua.indexOf("Trident/");
            if (msie > 0 || trident > 0 || edge > 0) // Holy fuck!!! the user is running worst fucking piece of shit browser in the universe!
                return true;
            else // Another browser
                return false;
        }

        $form.AddDocNote = function (info) {
            var $n = $("<span>");
            if (info) {
                var top = info.top;
                var left = info.left;

                $.each(info, function (key, value) {
                    if (key.indexOf("data-") == 0) {
                        $n.attr(key, value);
                    }
                });

                $n.css({ top: top, left: left });
                $n.text(info.text);
            } else {
                $n.css({ top: $(window).scrollTop() });
                $n.text($.fn.SmartformTexts.DocNotes.DefaultNoteText);
            }

            $n.addClass("docnote hidden-xs hidden-sm hidden-md");

            if ($form.SupportContEditPlainText) {
                $n[0].contentEditable = "plaintext-only";
            }
            else {
                $n.attr("contenteditable", "true");
                $n.on("paste", function (e) {
                    var content;

                    e.preventDefault();

                    if (e.originalEvent.clipboardData) {
                        content = (e.originalEvent || e).clipboardData.getData("text/plain");
                        document.execCommand("insertText", false, content);
                    }
                    else if (window.clipboardData) {
                        content = window.clipboardData.getData("Text");
                        if (window.getSelection)
                            window.getSelection().getRangeAt(0).insertNode(document.createTextNode(content));
                    }
                });
            }

            var $c = $("<span/>");
            $c.css({ position: "absolute" });
            $c.hide();
            $c.append($n);
            $form.find(".docnotescontainer").append($c);

            $n.draggable();
            $n.on("click mousedown", function () {
                if (!$(this).is(":focus")) $(this).focus();
            });

            function isEmptyOrSpaces(str) {
                return str === null || str.match(/^ *$/) !== null;
            }

            $n.on("blur", function () {
                var txt = $(this).text();
                if (txt === null || txt.replace("\r", "").replace("\n", "") == "")
                    $(this).parent().remove();
                else
                    if (!$form.SupportContEditPlainText) $(this).text(txt);
            });

            if (info) $c.show();
            else $c.fadeIn(250, function () {
                $form.SelectElementContents($n[0]);
                $n.focus();
            });

            return $n;
        };

        $form.SelectElementContents = function (el) {
            var range = document.createRange();
            range.selectNodeContents(el);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
        };

        $form.WrapInput = function ($item) {
            if ($item.length == 0) return null;
            var writeFunc;
            var getFunc;

            // Value field element
            var fieldName = $item.attr("name");
            if (fieldName == "" || fieldName == null) return null;

            if ($item.is("[type=\"radio\"]")) { // Radio boxes
                var $container = $item.closest("[data-array] > *");
                if ($container.length == 0) $container = $form;
                $item = $container.find("input[type=radio][name=\"" + fieldName + "\"]");
                getFunc = function () {
                    var $selected = $item.filter(":checked");
                    if ($selected.length == 1)
                        return $selected.val();
                    return null;
                };
                writeFunc = function (value) {
                    if (value == null) $item.prop("checked", false);
                    $item.each(function () {
                        var $t = $(this);
                        if ($t.val() == value && !$t.prop("checked")) {
                            $t.click();
                            $t.prop("checked", true);
                            $t.trigger("change");
                        }
                    });
                    $form.UpdateCalculations();
                };

            } else if ($item.is("[type=\"checkbox\"]")) { // Checkboxes
                getFunc = function () {
                    return $item.prop("checked");
                };
                writeFunc = function (value) {
                    var curval = $item.prop("checked");
                    if (curval != value) {
                        $item.click();
                        $item.prop("checked", value);
                        $item.trigger("change");
                    }

                    $form.UpdateCalculations();
                };
            } else if ($item.is("[type=\"date\"]")) { // Date fields
                getFunc = function () {
                    return $item.val() || "";
                };
                writeFunc = function (value) {
                    if (value instanceof Date) {
                        var day = ("0" + value.getDate()).slice(-2);
                        var month = ("0" + (value.getMonth() + 1)).slice(-2);
                        var datestr = value.getFullYear() + "-" + (month) + "-" + (day);

                        $item.val(datestr);
                    }
                    else {
                        if (value != null && value.indexOf("T") > 0)
                            value = value.split("T")[0];
                        $item.val(value);
                    }
                    $item.trigger("change");

                    $form.UpdateCalculations();
                };
            } else if ($item.is("[type=\"month\"]")) { // Date fields
                getFunc = function () {
                    return $item.val() || "";
                };
                writeFunc = function (value) {
                    if (value instanceof Date) {
                        var month = ("0" + (value.getMonth() + 1)).slice(-2);
                        var datestr = value.getFullYear() + "-" + (month);

                        $item.val(datestr);
                    }
                    else {
                        if (value != null && value.indexOf("T") > 0)
                            value = value.split("T")[0];
                        var parts = value.split("-");
                        if (parts.length == 3)
                            value = parts[0] + "-" + parts[1];
                        $item.val(value);
                    }
                    $item.trigger("change");

                    $form.UpdateCalculations();
                };
            } else if ($item.is("[type=\"datetime-local\"]") || $item.is("[type=\"datetime\"]")) { // Date fields
                getFunc = function () {
                    return $item.val() || "";
                };
                writeFunc = function (value) {
                    if (value instanceof Date) {
                        var day = ("0" + value.getDate()).slice(-2);
                        var month = ("0" + (value.getMonth() + 1)).slice(-2);
                        var hour = ("0" + value.getHours()).slice(-2);
                        var minute = ("0" + value.getMinutes()).slice(-2);
                        var datestr = value.getFullYear() + "-" + (month) + "-" + (day) + "T" + hour + ":" + minute;
                        $item.val(datestr);
                    }
                    else $item.val(value);
                    $item.trigger("change");

                    $form.UpdateCalculations();
                };
            } else if ($item.is("select")) { // Select types
                var multiple = $item.is("[multiple]");
                getFunc = function () {
                    return $item.val() || "";
                };
                writeFunc = function (value) {
                    if (value == null) value = multiple ? [] : "";
                    if ((typeof value) == "string" && $item.is("[data-func=link]")) {
                        // Migrate old data link string values
                        value = value.split(",");
                    }

                    if ($form.AutoAddMissingOptions && value != null) {
                        var setval = value;

                        if (!(setval instanceof Array))
                            setval = [setval];

                        $.each(setval, function (index9, findval) {
                            var exists = false;
                            $item.find("option").each(function () {
                                if (this.value == findval) {
                                    exists = true;
                                    return false;
                                }
                            });

                            //if ($item.find("option[value=\"" + value + "\"]").length == 0)
                            if (!exists)
                                $item.append("<option>" + findval + "</option>");
                        });
                    }
                    $item.val(value);
                    $item.trigger("change");
                    $form.UpdateCalculations();
                };
            }
            else { // All other input types
                getFunc = function () {
                    return $item.val() || "";
                };
                writeFunc = function (value) {
                    $item.val(value);
                    $item.trigger("change");
                    $form.UpdateCalculations();
                };
            }

            var cloneFunc = function ($e) { // Clone this handler for a new surface
                var query = "[name=\"" + fieldName + "\"]:input";
                return $form.WrapInput($e.find(query).addBack().filter(query)/*.not("[data-array]>*")*/);
            };

            $item.on("input change", function () {
                $item.trigger("modify", [$item, $form, getFunc, writeFunc]);
            });

            return { Field: fieldName, Get: getFunc, Write: writeFunc, AttachCopy: cloneFunc };
        };

        $form.WrapFuncInput = function ($item) {
            if ($item.length == 0) return null;
            var fieldName = $item.attr("data-name");
            if (fieldName == "" || fieldName == null) return null;
            var oldval = $item.text();

            var writeFunc = function (value) {
                $item.text(value);
                oldval = value;
                $item.trigger("change");
                return;
            };

            var getFunc = function () {
                return $item.text();
            };

            var cloneFunc = function ($e) { // Clone this handler for a new surface
                var query = "[data-func=\"input\"][data-name=\"" + fieldName + "\"]";
                return $form.WrapFuncInput($e.find(query).addBack().filter(query).first()/*.not("[data-array]>*")*/);
            };

            $item.on("input keyup click", function () {
                var newval = getFunc();
                if (oldval == newval) return;
                oldval = newval;
                $item.trigger("modify", [$item, $form, getFunc, writeFunc]);
            });

            return { Field: fieldName, Get: getFunc, Write: writeFunc, AttachCopy: cloneFunc };
        };

        $form.WrapArray = function ($item) {
            if ($item.length == 0) return null;
            var arr = $item.attr("data-array");
            var writeFunc = function (value) {
                $form.WriteItems($item, value);
                return;
            };
            var getFunc = function () {
                var d = [];
                var ci = 0;
                $.each($item.children().not("[data-noarray]"), function (i, child) {
                    var $c = $(child);
                    if ($c.is(".ui-sortable-placeholder,.ui-draggable,.ui-sortable-helper,.autoinsert")) return; // Ignore jquery ui sorting placeholders + autoinsert row

                    var item = $form.Read($c);
                    d[ci++] = item;
                });
                return d;
            }

            var cloneFunc = function ($e) { // Clone this handler for a new surface
                var query = "[data-array=\"" + arr + "\"]";
                return $form.WrapArray($e.find(query).addBack().filter(query).first()/*.not("[data-array]>*")*/);
            };

            return { Field: arr, Get: getFunc, Write: writeFunc, AttachCopy: cloneFunc };
        };


        $form.Read = function ($item, o) {
            var readTimer = null;
            var hpanels = $form.find(".collapsedPanel");

            if ($item == null) {
                var notes = $form.GetNotes();
                if (notes.length > 0) o = { DocumentNotes: notes };
                $item = $form;

                readTimer = new Date();
            }
            if ($item == null) return null;

            if (o == null) {
                o = {};
                var variant = $item.attr("data-variant");
                if (variant != null) o["ObjectVariant"] = variant;
            }

            hpanels.removeClass("collapsedPanel");

            var fields = $item.data("LookUp");
            if (fields == null) {
                fields = $form.FindFields($item);
                $item.data("LookUp", fields);
            }

            $.each(fields, function (index, f) {
                //$form.ReadField($field, o);
                o[f.Field] = f.Get();
            });
            hpanels.addClass("collapsedPanel");
            if (readTimer != null) {
                var diffMs = (new Date()).getTime() - readTimer.getTime();
                $form.Log("READ entire form (" + diffMs + "ms)");
            }

            return o;
        };
        $form.Log = function (text) {
            if (window.console && typeof window.console.log !== "undefined") {
                console.log("Smartform.JS: " + text);
            }
        };
        $form.FindFields = function ($item, list) {
            if (list == null) {
                if ($item.is("[data-lookup-index]")) {
                    var index = parseInt($item.attr("data-lookup-index")); //  Get lookup index
                    var existing = $form.LookUps[index]; // Get existing lookup
                    if (existing == null) {
                        // Not built yet, build on demand
                        $form.Log("*** Triggered index build for index " + index + " array: " + $item.parent().attr("data-array") + " variant: " + $item.attr("data-variant"));
                        existing = $form.FindFields($item, []);
                        $form.LookUps[index] = existing;
                        return existing;
                    }
                    // Reattach from existing map
                    var copy = [];
                    $.each(existing, function (i, f) {
                        var l = f.AttachCopy($item);
                        if (l != null) copy.push(l);
                    });

                    return copy;
                } else {
                    $item.attr("data-no-lookup-index", "1");
                    $form.Log("*** NO LOOKUP INDEX! Triggered index build for " + $item.parent().attr("data-array") + " variant: " + $item.attr("data-variant"));
                }
                list = [];
            }

            if ($item.is("input,select,textarea")) {
                // Value field element
                var inp = $form.WrapInput($item);
                //$form.Log("*** Added input " + $item[0].tagName);
                if (inp != null) list.push(inp);
                return list;
            }
            if ($item.is("[data-name][data-func=input]")) {
                var finp = $form.WrapFuncInput($item);
                //$form.Log("*** Added func-input");
                if (finp != null) list.push(finp);
                return list;
            }

            // Array element
            if ($item.attr("data-array") != null) {
                //$form.Log("*** Added array " + $item.attr("data-array"));
                $form.FindFields($item.children("[data-noarray]"), list);
                list.push($form.WrapArray($item));
                return list;
            }

            $item.children().each(function () {
                $form.FindFields($(this), list);
            });
            return list;
        };

        $form.WriteItems = function ($ctrl, items) {
            var $template = $ctrl.data("data-template");
            var autoinsert = $ctrl.attr("data-autoinsert");

            if (autoinsert) $ctrl.children(".autoinsert").remove(); // Remove any auto insert
            var existing = $ctrl.children().not("[data-noarray]");

            if (items != null && items.constructor === Array) {
                $.each(items, function (index, item) {
                    if (existing.length > index) {
                        // Use old existing structure element
                        //$form.WriteItem($ctrl, this, $template);
                        $form.WriteSection($(existing[index]), item);
                        $form.UpdateCalculations();

                    } else {
                        // Expand structure with new elements
                        $form.AddItem($ctrl, this, $template);
                    }
                });

                // Remove overflowing structure
                for (var i = items.length; i < existing.length; i++)
                    $(existing[i]).remove(); // Remove overflow elements
            }
            else {
                //existing.remove(); // Remove all overflowing elements
            }
            if (autoinsert) {
                existing.removeClass("autoinsert");
                attachAutoInsert($ctrl, $form, true);
            }

        };
        /// $list = Target [data-array] jquery $(item) to add to
        /// item = data to add (including variant if arrays has variants)
        /// $template = (optional) for performance optimization, the template markup can be sent, otherwise it is calced inside the method
        $form.AddItem = function ($list, item, $template, addClass) { // TODO: Optimize this function further
            if (!$template) {
                $template = $list.data("data-template");
            }

            if (!$template) return false;

            var $nr;
            if (item.ObjectVariant && item.ObjectVariant != "") {
                var $variant = $template.children("[data-variant=\"" + item.ObjectVariant + "\"]");
                if ($variant.length == 1) $nr = $variant.clone();
                else $nr = $template.children().first().clone();
            } else {
                $nr = $template.children().first().clone();
            }
            if (addClass) $nr.addClass(addClass);

            var $autoins = $list.children(".autoinsert");
            if ($autoins.length > 0) {
                $autoins.last().before($nr);
            }
            else $list.append($nr);

            $nr.HookActions($form);

            $form.WriteSection($nr, item);
            $form.UpdateCalculations();
            $nr.trigger("added", [$nr, $form]);
            return $nr;
        };

        $form.ChangeVariant = function ($element, toVariantName) {
            var $list = $element.parent();
            var $template = $list.data("data-template");
            if (!$template) {
                $form.Log("FAILED: Change element variant to " + toVariantName)
                return false;
            }
            var $nr;

            var $variant = toVariantName != "" ? $template.children("[data-variant=\"" + toVariantName + "\"]") : [];
            if ($variant.length == 1) $nr = $variant.clone();
            else $nr = $template.children().first().clone();

            var data = {};
            $form.Read($element, data);
            $element.replaceWith($nr);

            $nr.HookActions($form);
            $form.WriteSection($nr, data);
            $form.UpdateCalculations();
            $nr.trigger("added", [$nr, $form]);

            $form.Log("Change element variant to " + toVariantName)

            return $nr;
        };

        $form.ApplyPendingOperations = function () {
            while ($form.PendingOperations != null && $form.PendingOperations.length > 0) {
                $form.PendingOperations[0]();
                $form.PendingOperations.shift();
            }
        };

        $form.WriteSection = function ($section, data) {
            var fields = $section.data("LookUp");
            if (fields == null) {
                fields = $form.FindFields($section);
                $section.data("LookUp", fields);
            }

            if (data.DocumentNotes != null) {
                $form.find(".docnotescontainer").html(""); // Clear
                $form.AddNotes(data.DocumentNotes);
            }

            $.each(fields, function (index, f) {
                var value = data[f.Field];
                if (typeof value !== "undefined") {
                    f.Write(value);
                };
            });
        };

        $form.StartTransaction = function () {
            if ($form.Connected == false) return; // Already started transaction
            $form.$placeholder = $("<span />").insertAfter($form)
            $form.detach();
            $form.Connected = false;
        };

        $form.EndTransaction = function () {
            if ($form.Connected == true) return; // Already ended transaction
            $form.insertBefore($form.$placeholder);
            $form.$placeholder.remove();
            $form.$placeholder = null;
            $form.Connected = true;
            $form.ApplyPendingOperations();
        };


        $form.Write = function (data) {
            var writeTimer = new Date();
            if (data == null) data = {};

            // Set json to form
            $form.StartTransaction();
            $form.Writing = true;
            $form.WriteSection($form, data);



            $form.find("[data-toggle=buttons] input[type=checkbox],[data-toggle=buttons] input[type=radio]").each(function (index, item) {
                var $i = $(item);
                if ($i.prop("checked")) {
                    $i.closest("label").addClass("active");
                } else {
                    $i.closest("label").removeClass("active");
                }
            });
            $form.EndTransaction();

            //Rewrite data-link values (to update select2 lists)
            $form.find("textarea[data-func=\"autogrow\"]").trigger("autogrow");
            $form.Writing = false;
            var $fields = $form.find("[data-func=\"link\"],[data-action=\"link\"]");
            $fields.trigger("resetcache"); // Reload dynamic databinded items
            $form.Writing = true;
            $fields.trigger("change"); // Trigger databinded items to refresh in GUI
            $form.Writing = false;

            var diffMs = (new Date()).getTime() - writeTimer.getTime();
            $form.Log("WRITE entire form (" + diffMs + "ms)");


            $form.LoadDocCompleted();
        };

        $form.Validate = function () {
            var result = true;
            $form.find("[data-func=reqvalidate]").not(".autoinsert [data-func=reqvalidate]").each(function (index, item) {
                if (!result) return;

                var $item = $(item);
                var $container = $item.closest("[data-array] > *");
                if ($container.length == 0) $container = $form;

                var name = $item.attr("data-target");
                var pos = $item.attr("data-container");

                var msg = $item.attr("data-message");
                if (msg == null || msg == "") msg = "This field is required!";

                var $field = $container.find("[name=\"" + name + "\"]");
                var value = "";
                if ($field.length == 0) {
                    $field = $container.find("[data-func=\"input\"][data-name=\"" + name + "\"]");
                    value = $field.text();
                } else {
                    value = $field.val();
                }

                var $showAt = pos ? $form.find(pos).first() : $container.find("[data-name=\"" + name + "\"],[name=\"" + name + "\"]");
                if (!$showAt.is(":visible")) $showAt = $showAt.closest(":visible");
                if (value == null || value == "") {
                    var $popover = $showAt.popover({ title: $.fn.SmartformTexts.Validation.ErrorTitle, content: msg, container: $form });
                    $showAt.popover("show");
                    $form.find(".popover").on("click", function () {
                        $showAt.popover("hide");
                    });
                    if (!$showAt.isOnScreen()) $showAt.scrollIntoScreen();
                    result = false;
                } else {
                    $showAt.popover("hide");
                }
            });
            return result;
        };
        $form.AttachSyncItem = function ($sourceItem, $targetItem) {
            $targetItem.find("[data-bind]").addBack("[data-bind]").each(function (index, item) {
                var $i = $(item);
                var fieldName = $i.attr("data-bind");
                var $field = $sourceItem.find("[name=\"" + fieldName + "\"],[data-name=\"" + fieldName + "\"]").addBack("[name=\"" + fieldName + "\"],[data-name=\"" + fieldName + "\"]").first();
                if ($field.length == 0) {
                    $form.Log("Field not found " + fieldName);
                }
                var updateFunc = function () {
                    var fieldValue = null;
                    var sync = $field.closest("[data-array]").attr("data-array");
                    var sync2 = $i.closest("[data-sync]").attr("data-sync");
                    if (sync != sync2) return true; // Continue, this is an item within a nested sync. Should not be attached.

                    // Read value
                    if ($field.is(":input")) {
                        fieldValue = $field.val();
                    } else {
                        fieldValue = $field.text();
                    }

                    // Write value
                    if ($i.is(":input")) {
                        $i.val(fieldValue);
                    } else {
                        $i.text(fieldValue);
                    }
                };
                $field.on("change input keyup blur", updateFunc);
                updateFunc();

            });
        };
        $form.SyncArray = function ($target, $source, arrayName) {
            var sourceItems = $source.children("*:not([data-noarray],.ui-effects-placeholder,.autoinsert)");
            var sourceCount = sourceItems.length;

            var targetCount = $target.children("*:not([data-noarray],.ui-effects-placeholder,.autoinsert)").length;
            while (targetCount < sourceCount) { // Add missing items
                var $targetItem = $form.AddItem($target, {});
                targetCount++;
            }

            while (targetCount > sourceCount) { // Remove excessive items
                $target.children().not("[data-noarray],.autoinsert").last().remove();
                targetCount--;
                console.log("Remove overflow in target");
            }
        };

        $form.PrepareBrowserSupport = function () {
            // Some fixes for browser support
            if ($form.IsPieceOfShitBrowser()) {
                $form.find("td[data-func=input]").each(function (index, item) {
                    var $h = $(item);
                    // Insert div inside td input fields
                    var $div = $("<div data-placeholder=\"" + $h.attr("data-placeholder") + "\" data-func=\"input\" data-name=\"" + $h.attr("data-name") + "\"></div>");
                    $div.html($h.html()); // Move content
                    $h.html(""); // Clear div
                    $h.append($div); // Append container

                    $h.attr("data-func", "focus");
                    $h.attr("data-name", null);
                    $h.css("cursor", "text");
                });
            }
        };

        $form.InitTemplateFields = function () {
            $form.find("[data-func=template]").each(function (index, item) {
                var $c = $(this);
                var tn = $c.attr("data-template");
                var $t = $form.find("[data-name=\"" + tn + "\"]").first();
                $c.html($t.html()); // Copies template into this field
                $c.data("template", $t.data("template"));
                $form.Log("Added template " + tn + " to content");
            });
        };

        $form.Initialize = function () {
            $form.Writing = true;
            $form.PrepareBrowserSupport(); // Browser support
            $form.InitTemplateFields();
            $form.FormLayout(); // Execute layout directives

            $form.PrepareArrayLookUps(); // Map and tag arrays for on demand index building
            $form.HookActions($form);
            $form.Writing = false;
        };

        var b64toBlob = function (b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;

            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
                var byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }

            var blob = new Blob(byteArrays, { type: contentType });
            return blob;
        };
        $form.SaveToServer = function (url, values, progress, $cancelBtn) {
            var data = new FormData();
            for (var item in values) {
                var value = values[item];
                if (typeof value === 'object') data.append(item, JSON.stringify(value));
                else data.append(item, values[item]);
            }

            var attachments = 0;
            $form.find("input[type=file][data-upload]").each(function (i, item) {
                var f = item.files[$(item).attr("data-fileindex") || 0];
                var filename = $(item).attr("data-upload");
                data.append("attachments[]", f, filename);
                attachments++;
            });

            $form.find("img[data-upload]").each(function (index, item) {
                var base64 = $(item).attr("src").split(";base64,")[1];
                var blob = b64toBlob(base64);
                var filename = $(item).attr("data-upload");
                data.append("attachments[]", blob, filename);
                attachments++;
            });

            var xhr = null;
            var ajax = $.ajax({
                url: url,
                type: "POST",
                dataType: "json",
                data: data,
                cache: false,
                contentType: false,
                processData: false,
                xhr: function () {
                    xhr = $.ajaxSettings.xhr();

                    if (attachments > 0 && progress) {
                        xhr.upload.onprogress = function (evt) {
                            if (ajax != null) {
                                progress(evt.loaded, evt.total);
                            }
                        };
                    }

                    return xhr;
                }
            });

            /*$me.FileUpload.AbortUploadBtn.off("click");
            $me.FileUpload.AbortUploadBtn.on("click", function () {
                if (ajax != null) {
                    ajax.abort();
                    ajax.trigger("aborted");
                    ajax = null;
                }
            });*/
            return ajax;
        };
        $form.SaveAttachments = function (save, callback, progress, $cancelBtn) {
            var count = 0, total = 0, totalbytes = 0, transbytes = 0, success = true;
            $form.find("input[type=file][data-upload]").each(function (index, item) {
                if (item.files.length > 0) {
                    count++;
                    var file = item.files[$(item).attr("data-fileindex") || 0];
                    var filename = $(item).attr("data-upload");

                    var xhr = save(filename, file);
                    totalbytes += file.size;
                    if (xhr == null) {
                        success = false;
                        count--;
                        return;
                    }

                    var lastloaded = 0;
                    xhr.upload.addEventListener("progress", function (e) {
                        transbytes += e.loaded - lastloaded;
                        lastloaded = e.loaded;
                        if (progress && xhr != null) progress(transbytes, totalbytes);
                    }, false);

                    $cancelBtn.on("click", function () {
                        if (xhr == null) return;
                        xhr.onreadystatechange = null;
                        if (xhr != null) xhr.abort();
                        if (callback) callback(false, "Cancelled by user");
                        callback = null;
                    });

                    xhr.onreadystatechange = function (e) {
                        if (xhr.readyState == 4) {


                            if (xhr.status == 200) {
                                $(item).removeAttr("data-upload");
                            }
                            else
                                success = false;

                            count--;
                            if (progress) progress(transbytes, totalbytes);
                            if (count == 0) {
                                if (callback) callback(success);
                            }
                            xhr = null;
                        }
                    };
                }
            });

            $form.find("img[data-upload]").each(function (index, item) {
                count++;

                var data = $(item).attr("src").split(";base64,")[1];
                var blob = b64toBlob(data);
                var xhr = save($(item).attr("data-upload"), blob);
                totalbytes += blob.size;

                var lastloaded = 0;
                xhr.upload.addEventListener("progress", function (e) {
                    transbytes += e.loaded - lastloaded;
                    lastloaded = e.loaded;
                    if (progress && xhr != null) progress(transbytes, totalbytes);
                }, false);

                $cancelBtn.on("click", function () {
                    if (xhr == null) return;
                    xhr.onreadystatechange = null;
                    if (xhr != null) xhr.abort();
                    if (callback) callback(false, "Cancelled by user");
                    callback = null;
                });

                xhr.onreadystatechange = function (e) {
                    if (xhr.readyState == 4) {

                        if (xhr.status == 200)
                            $(item).removeAttr("data-upload");

                        count--;
                        if (progress) progress(transbytes, totalbytes);
                        if (count == 0) {
                            if (callback) callback(true);
                        }
                        xhr = null;
                    }
                };
            });

            total = count;
            if (count == 0) {
                if (callback) callback(success);
            }
            else {
                if (progress) progress(0, 100);
            }
        };

        $form.Initialize();

        return $form;
    };
    $.fn.autoform = function (data, options) {
        var $me = $(this);
        if (!options) options = {};

        function isInt(n) {
            return Number(n) === n && n % 1 === 0;
        }

        function isFloat(n) {
            return n === Number(n) && n % 1 !== 0;
        }

        $.each(data, function (key, value) {
            if (options.filter && options.filter(key)) return; // Skip field
            var required = false;
            if (options.required) required = options.required(key);

            var label = null;
            if (options.label) label = options.label(key);
            if (label == null) label = key;

            var $div = $("<div class=\"form-group\"><label>" + label + "</label></div>");
            if (required) $div.find("label").append(" <small class=\"text-danger glyphicon glyphicon-star required\"></small>")

            var $input = null;
            var list = false;
            var multiline = false;
            if (options.multiline) multiline = options.multiline(key);

            if (options.list) list = options.list(key);

            if (list) {
                $input = $("<select name=\"" + key + "\" class=\"form-control\" />");
                var populate = function (items) {
                    $input.empty();
                    $.each(items, function () {
                        var value = (this.value) ? this.value : this;
                        var text = (this.text) ? this.text : this;
                        $input.append("<option value=\"" + value + "\">" + text + "</option>");
                    });
                    $input.val(value);
                };

                if (typeof list === "function") {
                    list($input, value, populate);
                } else {
                    populate(list);
                }
            }
            else if (typeof value === "string" && multiline) {
                $input = $("<div data-func=\"input\" data-name=\"" + key + "\" class=\"form-control\" />");
                $input.text(value);
            }
            else {

                $input = $("<input name=\"" + key + "\" class=\"form-control\" />");
                var type = "";
                if (options.type) type = options.type(key);
                if (type) {
                    $input.attr("type", type);

                    if (type == "checkbox") {
                        $input.prop("checked", value);
                    }
                }
                else {
                    if (value instanceof Date) {
                        $input.attr("type", "date");
                        var day = ("0" + value.getDate()).slice(-2);
                        var month = ("0" + (value.getMonth() + 1)).slice(-2);
                        //var hour = ("0" + value.getHours()).slice(-2);
                        //var minute = ("0" + value.getMinutes()).slice(-2);
                        var datestr = value.getFullYear() + "-" + (month) + "-" + (day);// + "T" + hour + ":" + minute;
                        value = datestr;
                    }
                    else if (isInt(value)) {
                        $input.attr("type", "number");
                    }
                    else if (isFloat(value)) {
                        $input.attr("type", "number");
                        $input.attr("step", "0.01");
                    }
                    else if (typeof value === "boolean") {
                        $input.attr("type", "checkbox");
                        $input.prop("checked", value);
                    }
                }
                $input.val(value);
            }

            if (options.readonly && options.readonly(key)) {
                $input.attr("readonly", "readonly");
            }


            $div.append($input);
            $me.append($div);
        });
        return $me;
    };

    $.fn.FormLayout = function () {
        var $t = $(this);
        $t.find("[data-columns]").each(function () {
            var $e = $(this).FormLayout();

            var layout = "<table class=\"layout\">";
            var columns = $e.attr("data-columns");
            var labels = $e.attr("data-labels");

            $e.attr("data-columns", null);
            $e.attr("data-labels", null);
            //var w = 100 / columns;
            //w = "";
            var i = 0;

            $e.children().each(function () {
                if (i == 0) layout += "<tr>";
                i++;
                //layout += "<td width=\"" + w + "%\">";
                layout += "<td>";


                var lbl = $(this).attr("data-label");
                if (typeof lbl === "undefined") lbl = $(this).attr("name");

                if (typeof lbl !== "undefined") {
                    if (labels == "above") layout += "<label for=\"" + $(this).attr("name") + "\">" + lbl + "</label>";
                    if (labels == "watermark") $(this).attr("placeholder", lbl);
                }

                layout += this.outerHTML;

                layout += "</td>";

                if (i == columns) {
                    i = 0;
                    layout += "</tr>";
                }

            });
            layout += "</table>";
            $e.html(layout);
        });
        return $t;
    };

    function AttachSort($i, $form) {
        if ($i.attr("data-ico") != "1") {
            $i.attr("data-ico", "1");
            var ico = "hand-up";
            if ($i.attr("data-glyphicon") != null) ico = $i.attr("data-glyphicon");
            if (ico != "") $i.prepend("<span class=\"glyphicon glyphicon-" + ico + "\"></span> ");
        }

        if ($i.prop("tagName") == "BUTTON") {
            if (!$i.hasClass("btn")) {
                $i.addClass("btn");
                $i.addClass("btn-default");
            }
            $i = $i.replaceWith("<a data-ico=\"1\" title=\"" + $.fn.SmartformTexts.Actions.SortToolTip + "\" data-action=\"sort\" class=\"" + $i.attr("class") + "\">" + $i.html() + "</a>");
        }

        $i.click(function () { return false; });
    }
    function prepareArray($c, $form) {
        var $temp = null;
        var tname = $c.attr("data-template"); // Check for template reference (supports recursive)
        if (tname != null) {
            var $container = $form.find("[data-array=\"" + tname + "\"]");
            if ($container.length >= 1)
                $temp = $container.first().data("data-template").clone();
            else
                $form.Log("*** DATA-TEMPLATE references to '" + tname + "' not found!");
        }

        if ($temp == null) {
            $temp = $c.clone();
            $temp.children("[data-noarray]").remove();
        }


        if ($c.attr("data-clear") != null) {
            $temp.find("input").not("input[type=checkbox], input[type=radio]").attr("value", "");
            $temp.find("textarea,[data-func=input]").html("");
            $temp.find("input[type=checkbox], input[type=radio]").prop("checked", false);
        }

        $c.data("data-template", $temp);

        if ($c.attr("data-autoinsert") != null) {
            attachAutoInsert($c, $form, true);
        }
    }
    function attachAutoInsert($c, $form, forceAddElement) {
        // Auto insert empty row
        if ($c.children().length == 0 || forceAddElement) {
            // Add item
            $form.AddItem($c, {}, null, "autoinsert");
        }
        var $insert = $c.children().last()
        $insert.on("modify", function (e, $element, $form, getFunc) {
            if (!getFunc) return;
            var val = getFunc();
            if (val == "" || val == null) return;

            $insert.removeClass("autoinsert");
            $insert.off("modify");

            attachAutoInsert($c, $form, true);
        });
    }
    $.fn.scrollIntoScreen = function () {
        var offset = this.offset();
        var win = $(window);
        var dy = offset.top - win.height() / 2;
        if (dy < 0) dy = 0;
        $("html, body").animate({
            scrollTop: dy,
            scrollLeft: 0
        });
    };
    $.fn.isOnScreen = function () {

        var win = $(window);

        var viewport = {
            top: win.scrollTop(),
            left: win.scrollLeft()
        };
        viewport.right = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height();

        var bounds = this.offset();
        bounds.right = bounds.left + this.outerWidth();
        bounds.bottom = bounds.top + this.outerHeight();

        return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

    };
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    function guid() {
        return s4() + s4() + "-" + s4() + "-" + s4() + "-" +
            s4() + "-" + s4() + s4() + s4();
    }
    function createImgToolbar($i, $img, $current) {
        var $meny = $("<ul role=\"menu\" style=\"top:inherit;left:inherit\" class=\"dropdown-menu\"><li class=\"img\"><a>" +
            $.fn.SmartformTexts.ImgToolMenu.ViewImg + "</a></li><li><a class=\"reset\">" +
            $.fn.SmartformTexts.ImgToolMenu.ResetImg + "</a></li><li class=\"divider\"></li><li class=\"download\"><a>" + $.fn.SmartformTexts.ImgToolMenu.DownloadImg + "</a></li></ul>");

        $img.after($meny);
        $img.attr("data-toggle", "dropdown");
        $img.addClass("dropdown-toggle");
        $img.on("mousedown touchstart", function () {
            $meny.parent().removeClass("open");
        });

        if (window.Darkroom) {
            $($meny.find("a")[0]).text("View / edit");
        }

        $img.on("click contextmenu", function (e) {
            $meny.parent().addClass("open");
            $meny.position({
                my: "left top",
                of: e
            });

            return false;
        });
        $meny.find(".reset").on("click", function () {
            $current.val("");
            $current.change();
        });
        $meny.find(".download").on("click", function () {
            window.open($img.attr("data-href"), "_system");
        });
        if ($img[0].tagName == "IMG") {
            $meny.find(".img").on("click", function () {
                var $viewer = $("<div class=\"modal fade in needsclick\"><div class=\"modal-dialog modal-lg\" style=\"width:auto;max-width:95%\"><div class=\"modal-content\"><div class=\"modal-header\">" +
                    "<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button></div><div class=\"nobackground\">" +
                    "<img id=\"_sfImageViewer\" style=\"max-width:100%\"/></div></div></div></div>");
                $viewer.hide();
                $("body").append($viewer);

                var $target = $viewer.find("img");
                $target.attr("src", $img.attr("src"));

                $viewer.modal().on("hidden.bs.modal", function (e) {
                    $viewer.remove();
                });

                if (window.Darkroom) {
                    $viewer.find(".modal-header").append("<button type=\"button\" class=\"btn btn-default edit\">Edit image ...</button>");
                    $viewer.find(".edit").on("click", function () {

                        Darkroom.plugins["save"] = Darkroom.Plugin.extend({
                            defaults: {
                                callback: function () {
                                    this.darkroom.selfDestroy();

                                    var newImage = dkrm.sourceImage.toDataURL();
                                    $img.attr("src", newImage);
                                    var filename = "img-" + guid() + ".png";
                                    $current.val(filename);
                                    $current.trigger("loaded");
                                    $img.attr("data-upload", filename);
                                    $current.trigger("input").trigger("modify");

                                    $viewer.modal("hide");
                                }
                            },
                            initialize: function InitializeDarkroomSavePlugin() {
                                var buttonGroup = this.darkroom.toolbar.createButtonGroup();

                                this.destroyButton = buttonGroup.createButton({
                                    image: "save"
                                });
                                this.destroyButton.addEventListener("click", this.options.callback.bind(this));
                            },
                        });

                        var dkrm = new Darkroom("#_sfImageViewer", {
                            maxWidth: $target.width(),
                            maxHeight: $target.height(),
                            crop: {
                                ratio: 1
                            }
                        });
                    });
                }
            });
        } else {
            $meny.find(".img").remove();
        }
    }
    function validateImg($btn, $img) {
        var res = $btn.attr("data-imgres");
        if (res != null && res.split("x").length == 2) {
            var sizearr = res.split("x");
            var w = parseInt(sizearr[0]);
            var h = parseInt(sizearr[1]);

            if ($img[0].naturalWidth != w || $img[0].naturalHeight != h) {
                $.fn.Alert("Invalid image resolution<small> The required size is " + res + " and the specified image was " + $img[0].naturalWidth + "x" + $img[0].naturalHeight + "</small>");
                $img.attr("data-upload", null);
                $img.attr("src", null);
                return false;
            }

        }
        return true;
    }

    function AttachAdd($i, $form) {
        if ($i.attr("data-ico") != "1") {
            $i.attr("data-ico", "1");
            var ico = "plus-sign";
            if ($i.attr("data-glyphicon") != null) ico = $i.attr("data-glyphicon");
            if (ico != "") $i.prepend("<span class=\"glyphicon glyphicon-" + ico + "\"></span> ");
        } else {
            return; // Already attachaed
        }

        var targ = $i.attr("data-target");
        var $n = $i.data("array-target");
        if (typeof $n === "undefined") {
            $n = $i.closest("[data-array] > *"); // find container
            if ($n.length == 0) $n = $form;


            if (targ == null || targ == "") {
                $n = $n.closest("[data-array]");
            } else {
                $n = $n.find("[data-array=\"" + targ + "\"]").first(); // find array
            }

            if ($n.length == 0) {
                $.notify("Target Array '" + targ + "' not found for '" + $i.attr("data-action") + "' button");
                $i.hide();
                return;
            }
        }

        // grab a copy as new item template
        var $template;
        var variant = $i.attr("data-variant");
        if (variant != null) {
            $template = $n.data("data-template");
            //$template = $($n.data("data-template"));
            $template = $template.children("[data-variant=\"" + variant + "\"]");
        } else {
            $template = $n.data("data-template").children().first();
        }

        function AddItemAnimated($template, $target, addClass) {
            $form.LogUndoState("Lagt til ny rad i liste");
            var $copy = $template.clone(false);
            $copy.hide();
            if (addClass) $copy.addClass(addClass);
            var $autoins = $target.children(".autoinsert");
            if ($autoins.length > 0) {
                $autoins.last().before($copy);
            }
            else $target.append($copy);


            var fx = "drop";
            if ($copy.is("tr")) fx = "fade";
            $copy.HookActions($form);
            $form.UpdateCalculations();

            $copy.show(fx, {}, 100, function () {
                var $fe = $copy.find(":input,[contenteditable]").not(".skipautofocus,.skipautofocus *,[type=hidden],:hidden").first();
                if ($form.HasMouse) {
                    if ($fe.is("[contenteditable]")) $form.SelectElementContents($fe[0]);
                    else $fe.select();
                    $fe.focus();
                } else {
                    if (!$fe.isOnScreen()) $fe.scrollIntoScreen();
                }
            });

            $copy.trigger("added", [$copy, $form]);
            return $copy;
        }

        var $focus = null;

        $i.on("mousedown", function () {
            $focus = $form.find(":focus");

        });

        $i.on("click", function () {
            var $n2 = $n;
            if ($i.attr("data-focusinsert") && $focus != null) {
                var typeName = $n.attr("data-type");
                if ($focus.is("[data-array][data-type=\"" + typeName + "\"]")) {
                    $n2 = $focus;
                }
                else {
                    var $p2 = $focus.closest("[data-array] > *"); // Find first container
                    var $n2 = $p2.find("[data-array][data-type=\"" + typeName + "\"]").first(); // Sub container
                    if ($n2.length != 1) {
                        $n2 = $focus.closest("[data-array][data-type=\"" + typeName + "\"]");
                        if ($n2.length != 1) $n2 = $n;
                    }
                }
                $focus = null;
            }

            var $added = AddItemAnimated($template, $n2);
            $form.Read($added); // Ensure index build for new item
            return false;
        });

        $i.draggable({
            //opacity: 0.7,
            helper: "clone",
            containment: $form.Containment,
            //appendTo:"[data-type=\"" + $n.attr("data-type") + "\"]",
            connectToSortable: "[data-type=\"" + $n.attr("data-type") + "\"]"
        });

        /*$n.droppable({
            drop: function (event, ui) {
                ui.draggable.clone().appendTo($(this)).draggable();
            }
        });*/

    }
    function AttachLink($i, $form) {
        var targetType = $i.attr("data-target");
        var idField = $i.attr("data-idfield");
        var labelField = $i.attr("data-labelfield");
        var linkbackField = $i.attr("data-linkbackfield");
        var contquery = $i.attr("data-container");

        var $container;
        if (contquery != null) {
            $container = $i.closest(contquery);
        } else {
            $container = $form;
            contquery = "$form";
        }
        var $arrayItem = $i.closest("[data-array] > *");

        $i.select2({
            theme: "bootstrap",
            placeholder: $i.attr("placeholder"),
            dropdownAutoWidth: true,
            width: "auto"
        });

        var localidfieldname = $i.attr("data-idfield");
        $i.on("select2:select", function (e) {
            console.log("select2:select " + linkbackField + " " + $form.Writing);
            if (linkbackField != null && !$form.Writing) {
                // Set option with "myId" in the select in the remote array with "thatId" to selected = true
                var myId = $arrayItem.find("[name=\"" + localidfieldname + "\"]").first().val();
                var thatId = e.params.data.id;
                console.log(myId + " " + thatId);
                // Find remote arrays -> find remote item with removed id -> scan up to that array element -> find that elements linkback field
                var $remoteItem = $container.find("[data-array][data-type=\"" + targetType + "\"] [name=\"" + localidfieldname + "\"][value=\"" + thatId + "\"]").closest("[data-array] > *").find("select[name=\"" + linkbackField + "\"]");

                if ($remoteItem.length == 0) {
                    $.notify("Link back item not found: '" + targetType + "' within container: '" + contquery + "'", "warn");
                }
                else {
                    $remoteItem.trigger("resetcache");

                    // Remove my id from the remote list:
                    $remoteItem.find("option[value=\"" + myId + "\"]").attr("selected", true);

                    // Trigger change
                    $remoteItem.trigger("change");
                }
            }
        });
        $arrayItem.on("removing", function () {
            // Remove this item from all other remotely linking array items:
            if (linkbackField != null && !$form.Writing) {
                // Set option with "myId" in the select in the remote array with "thatId" to selected = false
                var myId = $arrayItem.find("[name=\"" + localidfieldname + "\"]").first().val();

                // Find remote arrays -> find remote item with removed id -> scan up to that array element -> find that elements linkback field
                var $remoteItems = $container.find("[data-array][data-type=\"" + targetType + "\"] [name=\"" + localidfieldname + "\"]").closest("[data-array] > *").find("select[name=\"" + linkbackField + "\"]");

                if ($remoteItems.length == 0) return;

                // Remove my id from the remote list:
                $remoteItems.find("option[value=\"" + myId + "\"]").remove();

                // Trigger change
                $remoteItems.trigger("change");
            }
        });
        $i.on("select2:unselect", function (e) {
            console.log("select2:unselect " + linkbackField + " " + $form.Writing);
            if (linkbackField != null && !$form.Writing) {
                // Set option with "myId" in the select in the remote array with "thatId" to selected = false
                var myId = $arrayItem.find("[name=\"" + localidfieldname + "\"]").first().val();
                var thatId = e.params.data.id;

                // Find remote arrays -> find remote item with removed id -> scan up to that array element -> find that elements linkback field
                var $remoteItem = $container.find("[data-array][data-type=\"" + targetType + "\"] [name=\"" + localidfieldname + "\"][value=\"" + thatId + "\"]").closest("[data-array] > *").find("select[name=\"" + linkbackField + "\"]");

                if ($remoteItem.length == 0) {
                    console.log("Link back item not found: '" + targetType + "' within container: '" + contquery + "'", "warn");
                    return;
                }

                // Remove my id from the remote list:
                $remoteItem.find("option[value=\"" + myId + "\"]").attr("selected", false);

                // Trigger change
                $remoteItem.trigger("change");
            }
        });

        function recursiveFillList($elements, itemArray) {
            $elements.each(function () {
                var $item2 = $(this);
                var idel = $item2.find("[name=\"" + idField + "\"],[data-name=\"" + idField + "\"]").first();
                if (idel.length == 1) {
                    var field = $item2.find("[data-name=\"" + labelField + "\"],[name=\"" + labelField + "\"]").first();
                    var label = field.text();
                    if (field.is(":input")) label = field.val();

                    var id = idel.text();
                    if (idel.is(":input")) id = idel.val();

                    itemArray.push({ id: id, text: label });
                }
            });
        };

        function reloadOptions() {
            if ($form.Writing) return;

            var html = "";
            if (!$form.LinkCache[targetType] && contquery == "$form") {
                $form.Log("Reload select options");
                var $elements = $container.find("[data-array][data-type=\"" + targetType + "\"] > *:not(.autoinsert)");
                var res = [];
                recursiveFillList($elements, res); // Must search for new array elements! New arrays may have been added!
                var list = "";
                var $sel = $("<select/>");
                $.each(res, function () {
                    $sel.append($("<option value=\"" + this.id + "\" />").text(this.text));
                });
                html = $sel.html();
                $form.LinkCache[targetType] = html;
            } else {
                html = $form.LinkCache[targetType];
            }
            var oldval = $i.val();

            $i.html(html);
            $i.val(oldval);
        };

        $i.on("select2:opening focus resetcache", reloadOptions);
    }
    function AttachRemove($i, $form) {
        if ($i.attr("data-ico") != "1") {
            $i.attr("data-ico", "1");

            var ico = "trash";
            if ($i.attr("data-glyphicon") != null) ico = $i.attr("data-glyphicon");
            if (ico != "") $i.prepend("<span class=\"glyphicon glyphicon-" + ico + "\"></span> ");
        }
        var targetArray = $i.attr("data-target"); // When specified remove last from the specified array
        var container = $i.attr("data-container");
        container = container ? $i.closest(container) : $form;

        var noconfirm = $i.attr("data-noconfirm");

        $i.on("click", function () {
            var $n = $i.data("array-target");
            if (targetArray) {
                $n = container.find("[data-array=\"" + targetArray + "\"] > *:not(.autoinsert)").last();
            } else $($n).trigger("depopover");
            if (typeof $n === "undefined") $n = this;
            $form.RemoveItem($n, noconfirm);
            return false;
        });
    }
    function AttachClone($i, $form) {
        if ($i.attr("data-ico") != "1") {
            $i.attr("data-ico", "1");
            var ico = "duplicate";
            if ($i.attr("data-glyphicon") != null) ico = $i.attr("data-glyphicon");
            if (ico != "") $i.prepend("<span class=\"glyphicon glyphicon-" + ico + "\"></span> ");
        }
        var targetArray = $i.attr("data-target"); // When specified remove last from the specified array
        var container = $i.attr("data-container");
        container = container ? $i.closest(container) : $form;

        $i.on("click", function () {
            $form.LogUndoState("Duplisert rad i liste");
            var $k = $i.data("array-target"); // Check for redirect to other than default source item

            if (typeof $k === "undefined") {
                $k = $(this).closest("[data-array] > *"); // Get reference to the containing source item
            }

            if (targetArray) {
                $k = container.find("[data-array=\"" + targetArray + "\"] > *").last();
            }

            $form.CloneItem($k);

            return false;
        });
    }
    function AttachConnect($i, $form) {
        var $i = $(this);
        if ($i.attr("data-ico") != "1") {
            $i.attr("data-ico", "1");

            var ico = "link";
            if ($i.attr("data-glyphicon") != null) ico = $i.attr("data-glyphicon");
            if (ico != "") $i.prepend("<span class=\"glyphicon glyphicon-" + ico + "\"></span> ");
        }
    }
    function AttachFile($i, $form) {
        var $file = $("<input type=\"file\" style=\"visibility:hidden;position:absolute;width:0;height:0\" />");
        if ($i.attr("accept")) $file.attr("accept", $i.attr("accept"));
        if ($i.attr("data-multiple") && $i.closest("[data-array]").length != 0) {

            var userAgent = (navigator && navigator.userAgent || '').toLowerCase();
            var edge = userAgent.match(/edge\/(\d+)/);
            var ie = userAgent.match(/(?:msie |trident.+?; rv:)(\d+)/);

            if (edge === null && ie === null) {
                $file.prop("multiple", true);
            }
        }
        var $current = $("<input type=\"hidden\" name=\"" + $i.attr("data-file") + "\" />");

        var $container = $i.closest("[data-array] > *");
        if ($container.length == 0) $container = $form;

        var added = false;
        if ($container.find("input[name=\"" + $i.attr("data-img") + "\"]").length > 0) {
            $current = $($container.find("input[name=\"" + $i.attr("data-img") + "\"]")[0]);
            added = true;
        }

        var $hasfile = $container.find("[data-name=\"" + $i.attr("data-file") + "\"]");
        var $nofile = $container.find("[data-name=\"" + $i.attr("data-nofile") + "\"]");
        var $filename = $container.find("[data-name=\"" + $i.attr("data-filename") + "\"]");
        $hasfile.hide();
        $i.addClass("needsclick");

        if ($i.attr("data-ico") != "1") {

            $i.attr("data-ico", "1");
            var ico = "paperclip";
            if ($i.attr("data-glyphicon") != null) ico = $i.attr("data-glyphicon");
            if (ico != "") $i.prepend("<span class=\"glyphicon glyphicon-" + ico + "\"></span> ");
            $i.before($i, $file);

            if (!added) {
                createImgToolbar($i, $hasfile, $current);
                $i.parent().append($current);
            }
        }


        $i.click(function () {
            // Use standard file upload
            $file.trigger("click");
        });

        $filename.on("change", function () {
            var src = $current.val();
            var filename = $filename.is(":input") ? $filename.val() : $filename.text();
            $hasfile.attr("data-href", $form.DownloadUrlPrefix + src + "&saveAsName=" + filename);
        });

        $current.on("change", function () {
            var src = $current.val();
            if (src != "") {
                $hasfile.on("load", function () {
                    $hasfile.off("load");
                });

                var filename = $filename.is(":input") ? $filename.val() : $filename.text();
                $hasfile.attr("data-href", $form.DownloadUrlPrefix + src + "&saveAsName=" + filename);
                $hasfile.show();
                $nofile.hide();
            } else {
                $nofile.show();
                $hasfile.hide();
                $hasfile.attr("data-href", null);
                $current.attr("data-filedata", null);
                $file.val(null);

                if ($filename.is(":input")) $filename.val("").trigger("change").trigger("modify");
                else $filename.text("").trigger("input").trigger("modify");

                if ($i.attr("data-deleteempty") != null) {
                    var $item = $i.closest("[data-array] > *");
                    $form.RemoveItem($item);
                }
            }
        });

        $file.on("change", function () {
            $file.attr("data-upload", null);
            if (this.files.length == 0) return; // No file selected

            var file = this.files[$file.attr("data-fileindex") || 0];
            $hasfile.show();
            $nofile.hide();
            var ext = file.name.split(".").pop(); // Get file extension
            var g = "file-" + guid() + "." + ext; // Create guid filename
            $file.attr("data-upload", g);
            $current.val(g);
            if ($filename.is(":input")) $filename.val(file.name).trigger("change").trigger("modify");
            else $filename.text(file.name).trigger("input").trigger("modify");

            if (this.files.length > 1 && !$file.attr("data-fileindex")) {
                var supported = true;
                try { this.files = this.files; }
                catch (e) { supported = false; }
                if (!supported) {
                    $.fn.Alert("Valg av flere filer støttes desverre ikke i nettleseren din.");
                } else {
                    var $dataArray = $i.closest("[data-array]");
                    if ($dataArray.length != 0) {
                        var files = this.files;
                        $.each(this.files, function (idx, val) {
                            if (idx == 0) return true;
                            var $newfile = $form.AddItem($dataArray, {}, null);
                            $newfile = $newfile.find("input[type=file]");
                            $newfile.attr("data-fileindex", idx);
                            $newfile[0].files = files;
                            $newfile.trigger("change");
                        });
                    }
                }
            }
        });
    }
    function AttachCamera($i, $form) {
        var $file = $("<input type=\"file\" accept=\"image/*\" style=\"visibility:hidden;position:absolute;width:0;height:0\" />");
        var $current = $("<input type=\"hidden\" name=\"" + $i.attr("data-img") + "\" />");

        var $container = $i.closest("[data-array] > *");
        if ($container.length == 0) $container = $form;

        var added = false;
        if ($container.find("input[name=\"" + $i.attr("data-img") + "\"]").length > 0) {
            $current = $container.find("input[name=\"" + $i.attr("data-img") + "\"]").first();
            added = true;
        }

        var $img = $container.find("[data-name=\"" + $i.attr("data-img") + "\"]").first();
        var $noimg = $container.find("[data-name=\"" + $i.attr("data-noimg") + "\"]").first();
        $img.hide();
        $i.addClass("needsclick");

        if ($i.attr("data-ico") != "1") {

            $i.attr("data-ico", "1");
            var ico = "camera";
            if ($i.attr("data-glyphicon") != null) ico = $i.attr("data-glyphicon");
            if (ico != "") $i.prepend("<span class=\"glyphicon glyphicon-" + ico + "\"></span> ");
            $i.before($i, $file);

            if (!added) {
                createImgToolbar($i, $img, $current);
                $i.parent().append($current);
            }
        }


        $i.click(function () {
            if (navigator.camera) {
                var cam = navigator.camera;

                var quality = $i.attr("data-imgquality");
                if (quality == null) quality = 75;
                else quality = parseInt(quality);

                var res = $i.attr("data-imgres");
                var twidth = 1280, theight = 1024;
                if (res != null && res.split("x").length == 2) {
                    var sizearr = res.split("x");
                    twidth = parseInt(sizearr[0]);
                    theight = parseInt(sizearr[1]);
                }

                if (quality == null) quality = 75;
                // Use cordova camera
                cam.getPicture(function (imageData) {
                    var g = "cam-" + guid() + ".jpg"; // Create guid filename
                    $img[0].src = "data:image/jpeg;base64," + imageData;
                    if (validateImg($i, $img)) {
                        $current.val(g);
                        $img.attr("data-upload", g);
                    }


                }, function () {

                }, {
                        quality: quality,
                        destinationType: cam.DestinationType.DATA_URL,
                        sourceType: cam.PictureSourceType.CAMERA,
                        allowEdit: true,
                        encodingType: cam.EncodingType.JPEG,
                        targetWidth: twidth,
                        targetHeight: theight,
                        /*popoverOptions: CameraPopoverOptions,*/
                        saveToPhotoAlbum: false
                    });
            } else {
                // Use standard file upload
                $file.trigger("click");
            }
            return false;
        });

        $current.on("change", function () {
            var src = $current.val();
            if (src != "") {
                $img.attr("src", $form.ThumbUrlPrefix + src);
                $img.attr("data-href", $form.DownloadUrlPrefix + src);
                $img.show();
                $noimg.hide();
            } else {
                $noimg.show();
                $img.hide();
                $img.attr("data-href", null);
                $img.attr("src", null);
                $img.attr("data-upload", null);
                $file.attr("data-upload", null);
                $file.val(null);
            }
        });
        $file.on("change", function () {
            if (this.files.length == 0) return; // No file selected
            $(".loading").stop(true, true).fadeIn(10);

            var loadfile = this.files[$file.attr("data-fileindex") || 0];
            $img[0].file = loadfile;
            $img.show();
            $noimg.hide();

            var reader = new FileReader();
            reader.onload = (function (targetImg) {
                return function (e) {
                    targetImg.src = e.target.result;

                    var ext = loadfile.name.split(".").pop().toLowerCase(); // Get file extension
                    var g = "cam-" + guid() + "." + ext; // Create guid filename

                    loadfile = null;

                    if (validateImg($i, $img)) {
                        $current.val(g);
                        $current.trigger("loaded");
                        $file.attr("data-upload", g);
                        $current.trigger("input");
                    } else {
                        $img.hide();
                        $noimg.show();
                    }
                    $(".loading").stop(true, true).fadeOut();
                };
            })($img[0]);
            reader.readAsDataURL(loadfile);
        });

        $img.on("error", function () {

            $(".loading").stop(true, true).fadeOut();
            $img.hide();
            $noimg.show();

            if ($file[0].files.length > 0) {
                $.fn.Alert($.fn.SmartformTexts.Image.TypeError);
                $file.val(null);
            } else {
                $.notify($.fn.SmartformTexts.Image.LoadError, "warn");
            }
            return;
        });
    }
    function AttachInput($h, $form) {
        if (!$h.is("[data-name]")) {
            $form.Log("Missing data-name attribute on data-func=input element.");
            return;
        }

        if ($h.is("[readonly]")) return;
        if ($h.attr("data-nolinebreak")) {
            var inGrid = $h.is("[data-func='grid'] *");
            $h.on("keypress", function (e) {
                if (inGrid && e.which == 13) {
                    $h.trigger("nextrow");
                    return false; // Cancel event
                }
            });
        } else {
            if (!$form.SupportContEditPlainText)
                $h.on("paste", function (e) {
                    var content;

                    e.preventDefault();

                    if (e.originalEvent.clipboardData) {
                        content = (e.originalEvent || e).clipboardData.getData("text/plain");
                        document.execCommand("insertText", false, content);
                    }
                    else if (window.clipboardData) {
                        content = window.clipboardData.getData("Text");
                        if (window.getSelection)
                            window.getSelection().getRangeAt(0).insertNode(document.createTextNode(content));
                    }
                });
        }

        $h.attr("spellcheck", "false");

        if ($form.SupportContEditPlainText) {
            $h[0].contentEditable = "plaintext-only";
        }
        else {
            $h.attr("contenteditable", "true");
        }

        if (!$form.SupportContEditPlainText)
            $h.keypress(function (e) {
                var sel, node, offset, text, textBefore, textAfter, range;

                sel = window.getSelection();

                // the node that contains the caret
                node = sel.anchorNode;

                // if ENTER was pressed while the caret was inside the input field
                if (node.parentNode === $h[0] && e.keyCode === 13) {

                    // prevent the browsers from inserting <div>, <p>, or <br> on their own
                    e.preventDefault();

                    // the caret position inside the node
                    offset = sel.anchorOffset;

                    // insert a '\n' character at that position
                    text = node.textContent;
                    textBefore = text.slice(0, offset);
                    textAfter = text.slice(offset) || " ";
                    node.textContent = textBefore + "\n" + textAfter;

                    // position the caret after that new-line character
                    range = document.createRange();
                    range.setStart(node, offset + 1);
                    range.setEnd(node, offset + 1);

                    // update the selection
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
            });

        $h.on("click", function () { $h[0].spellcheck = true; });
        var oldtext = "";
        $h.on("focus", function () {
            $h[0].spellcheck = true;
            oldtext = $h.text();
        });

        function setTextContent(element, text) {
            while (element.firstChild !== null)
                element.removeChild(element.firstChild); // remove all existing content
            element.appendChild(document.createTextNode(text));
        }

        $h.on("blur", function () {
            $h[0].spellcheck = false;
            var txt = $h.text();
            if (!$form.SupportContEditPlainText) {
                while (txt.length > 0 && txt.lastIndexOf("\n") == txt.length - 1)
                    txt = txt.substring(0, txt.length - 1);

                $h.text(txt); // Always set text value, as formatting may have been added
                if (txt == oldtext) return; // Not changed, skip delete
            }
            if (txt == oldtext) return; // Not changed, skip clean and delete
            if (txt == "" && $h.attr("data-deleteempty") != null) {
                var $item = $h.closest("[data-array] > *");
                $form.RemoveItem($item);
            }
        });
    }
    function AttachPasteImg($i, $form) {
        var $container = $i.closest("[data-array] > *");
        if ($container.length == 0) $container = $form;

        var $current = $("<input type=\"hidden\" name=\"" + $i.attr("data-img") + "\" />");
        var added = false;
        if ($container.find("input[name=\"" + $i.attr("data-img") + "\"]").length > 0) {
            $current = $container.find("input[name=\"" + $i.attr("data-img") + "\"]").first();
            added = true;
        }

        var $img = $container.find("[data-name=\"" + $i.attr("data-img") + "\"]").first();
        var $noimg = $container.find("[data-name=\"" + $i.attr("data-noimg") + "\"]").first();
        $img.hide();
        $i.addClass("needsclick");

        if ($i.attr("data-ico") != "1") {
            $i.attr("data-ico", "1");
            var ico = "paste";
            if ($i.attr("data-glyphicon") != null) ico = $i.attr("data-glyphicon");
            if (ico != "") $i.prepend("<span class=\"glyphicon glyphicon-" + ico + "\"></span> ");

            if (!added) {
                createImgToolbar($i, $img, $current);
                $i.parent().append($current);
            }
        }

        var inner = $i.html();
        $i.attr("contenteditable", "true");
        $i.attr("title", $.fn.SmartformTexts.PasteImg.ToolTipTitle);
        $i.attr("data-toggle", "popover");
        $i.attr("data-content", $.fn.SmartformTexts.PasteImg.ToolTipText);
        $i.on("change keyup keypress click", function () { if ($i.html() != inner) $i.html(inner); });
        $i.on("blur", function () { $i.popover("hide"); });

        $current.on("change", function () {
            var src = $current.val();
            if (src != "") {
                $img.on("load", function () {
                    $img.off("load");
                });
                $img.attr("src", $form.ThumbUrlPrefix + src);
                $img.attr("data-href", $form.DownloadUrlPrefix + src);
                $img.show();
                $noimg.hide();
            } else {
                $noimg.show();
                $img.hide();

                $img.attr("data-href", null);
                $img.attr("src", null);
                $img.attr("data-upload", null);
            }
        });
        $i.on("click", function () { return false; });
        $i.pasteImageReader(function (result) {
            var file = result.file;
            $img[0].file = file;
            $img.show();
            $noimg.hide();
            var ext = "png"; // Get file extension
            var g = "cam-" + guid() + "." + ext; // Create guid filename

            $img[0].src = result.dataURL;
            if (validateImg($i, $img)) {
                $current.val(g);
                $current.trigger("loaded");
                $img.attr("data-upload", g);
                $current.trigger("input").trigger("modify");
            } else {
                $img.hide();
                $noimg.show();
            }
            $i.html(inner);
        });
    }
    function AttachSketch($i, $form) {
        var $container = $i.closest("[data-array] > *");
        if ($container.length == 0) $container = $form;

        var $current = $("<input type=\"hidden\" name=\"" + $i.attr("data-img") + "\" />");
        var added = false;
        if ($container.find("input[name=\"" + $i.attr("data-img") + "\"]").length > 0) {
            $current = $container.find("input[name=\"" + $i.attr("data-img") + "\"]").first();
            added = true;
        }

        var $img = $container.find("[data-name=\"" + $i.attr("data-img") + "\"]").first();
        var $noimg = $container.find("[data-name=\"" + $i.attr("data-noimg") + "\"]").first();
        $img.hide();
        $i.addClass("needsclick");

        if ($i.attr("data-ico") != "1") {
            $i.attr("data-ico", "1"); // Processed
            var ico = "pencil";
            if ($i.attr("data-glyphicon") != null) ico = $i.attr("data-glyphicon");
            if (ico != "") $i.prepend("<span class=\"glyphicon glyphicon-" + ico + "\"></span> ");
            if (!added) {
                createImgToolbar($i, $img, $current);
                $i.parent().append($current);
            }
        }

        $i.attr("title", "Sketchpad");
        $i.on("click", function () {
            var $sketcher = $("<div class=\"modal fade needsclick\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\">" +
                "<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button><div class=\"clearfix\"></div></div><div class=\"modal-body\">" +
                "<canvas class=\"needsclick\" width=\"10\" height=\"320\"></canvas></div><div class=\"modal-footer\"><button class=\"btn btn-primary\">" +
                $.fn.SmartformTexts.Sketchpad.OKBtn + "</button><a class=\"btn btn-default\">" + $.fn.SmartformTexts.Sketchpad.CancelBtn + "</a></div></div></div></div>");
            $sketcher.hide();
            $("body").append($sketcher);
            var canvas = $sketcher.find("canvas")[0];

            $sketcher.find(".btn-primary").on("click", function () {
                $img[0].src = canvas.toDataURL();

                $img.show();
                $noimg.hide();
                var ext = "png"; // Get file extension
                var g = "cam-" + guid() + "." + ext; // Create guid filename
                $img.attr("data-upload", g);
                $current.val(g);
                $current.trigger("change");
                $sketcher.modal("hide");
                return false;
            });
            $sketcher.find(".btn-default").on("click", function () {
                $sketcher.modal("hide");
                return false;
            });

            $sketcher.modal().on("shown.bs.modal", function (e) { // showing
                $sketcher.find("canvas").attr("width", $sketcher.find(".modal-body").width()).sketch({
                    defaultColor: "#000000",
                    backColor: "#FFFFFF",
                    defaultSize: 4
                });
            });


            $sketcher.modal().on("hidden.bs.modal", function (e) {
                $sketcher.remove();
            });
        });

        $current.on("change", function () {
            var src = $current.val();
            if ($img.attr("data-upload") == src) return; // Upload is queued, don't load img
            if (src != "") {
                $img.on("load", function () {
                    $img.off("load");
                });
                $img.attr("src", $form.ThumbUrlPrefix + src);
                $img.attr("data-href", $form.DownloadUrlPrefix + src);
                $img.show();
                $noimg.hide();
            } else {
                $noimg.show();
                $img.hide();
                $img.attr("data-href", null);
                $img.attr("src", null);
                $img.attr("data-upload", null);
            }
        });
    }
    function AttachRadio($t, $form) {
        $t.find("input[type=checkbox]").change(function () { // Mutual exclusive checkboxes
            var $input = $(this);
            var $group = $input.closest(".btn-group,.radiogroup");
            var name = $input.attr("name");
            $group.find("input[type=checkbox]").not($input).prop("checked", false);
            $group.find("input[type=checkbox]:not(:checked)").not($input).closest("label").removeClass("active");
        });
    }
    function AttachCollapse($t, $form) {
        $t.on("change", function () {
            var $c = $(this);
            var $sec = $c.closest($c.attr("data-container")).find($c.attr("data-body"));
            if ($c.prop("checked")) {
                $sec.removeClass("collapsedPanel");
                //$sec.show();
                $sec.find("textarea[data-func=autogrow]").trigger("change");
            }
            else $sec.addClass("collapsedPanel"); // $sec.hide();
        }).trigger("change");
    }
    function AttachArrays($t, $form) {
        var syncs = false;
        $t.find("[data-array],[data-sync]").addBack("[data-array],[data-sync]").each(function () {
            var $c = $(this);
            prepareArray($c, $form);

            if ($c.is("[data-array]") && $c.data("sortinited") == null) {
                $c.data("sortinited", "1");
                var name = $c.attr("data-type");
                if (name == null || name == "") name = $c.attr("data-template");
                if (name == null || name == "") name = $c.attr("data-array");
                $c.attr("data-type", name);
                var beforestate;
                var placeholder = $c.attr("data-placeholderclass");
                $c.sortable({
                    connectWith: "[data-type=\"" + name + "\"]", //allow move between simmillare or recursive lists
                    handle: "[data-action=sort]",
                    helper: function (e, ui) {
                        var $helper = ui.clone();
                        if (ui.height() > 100) {
                            ui.css("max-height", "100px");
                            $helper.css("max-height", "100px");
                        }

                        return $helper;

                    },
                    placeholder: placeholder,
                    containment: $form.Containment,
                    start: function (e, ui) {
                        if (!ui.item.is("[data-action=\"add\"]")) {
                            $form.Log("Drag start");
                            beforestate = $form.Read();
                        }
                    },
                    forceHelperSize: true,
                    //forcePlaceholderSizeType: true,
                    stop: function (event, ui) {
                        ui.item.css("max-height", "");
                        if (ui.item.attr("data-action") == "add") {
                            $form.LogUndoState("Added item", beforestate);

                            var $i = ui.item;

                            var $copy = $c.data("data-template");
                            var variant = $i.attr("data-variant");
                            if (variant != null) {
                                $copy = $copy.children("[data-variant=\"" + variant + "\"]").first();
                            } else {
                                $copy = $copy.children().first();
                            }

                            var $copy = $copy.clone();
                            ui.item.replaceWith($copy);
                            $copy.HookActions($form);
                            $form.FocusElement($copy);
                            $form.Read($copy); // Ensure index build for new item
                            $form.UpdateCalculations();
                        }
                        else {
                            $form.LogUndoState("Sortert liste", beforestate);
                            $form.UpdateCalculations();
                            var $i = ui.item;
                            $i.trigger("sorted");
                        }
                        if (ui.helper) ui.helper.remove();
                    }
                });
            }
            if ($c.is("[data-sync]")) { // This array is / is ALSO to be data-synched
                //alert("sync!");
                $c.children().not("[data-noarray]").remove(); // clear content items

                var arrayName = $c.attr("data-sync");
                var container = $c.attr("data-container");
                var $container = null;
                if (container == null || container == "") {
                    $container = $form;
                } else {
                    $container = $c.closest(container);
                }
                var $source = $container.find("[data-array=" + arrayName + "]");

                $source.on("added", function () {
                    $form.SyncArray($c, $source, arrayName); // Add new items as in source or sorted
                });
                $source.on("removed", function (e, index, $array, $item) {
                    $form.Log("Removed synced item " + index);

                    var $targetItems = $c.children().not("[data-noarray]");
                    var $targetItem = $($targetItems[index]);

                    var index = $targetItem.index();
                    var $arr = $targetItem.parent();

                    $targetItem.remove();
                    $targetItem.trigger("removed", [index, $arr, $targetItem]);
                    $arr.trigger("removed", [index, $arr, $targetItem]);
                });
                $source.on("sorted", function () {
                    // Remove all and re-add to resync the list
                    $c.empty();
                    $form.SyncArray($c, $source, arrayName); // Add new items as in source or sorted
                });
                $c.on("added", function () { // A new item has been added. Attach data-binding.
                    var $targetItem = $c.children().last();
                    var $sourceItems = $source.children().not("[data-noarray]");
                    var index = $targetItem.parent().children().not("[data-noarray]").index($targetItem);

                    $form.AttachSyncItem($($sourceItems[index]), $targetItem);



                });

                $form.SyncArray($c, $source, arrayName);


            }
        });
        //if (syncs) $form.SyncArrays(null, $t);
    }
    function AttachVariant($c, $form) {
        var $element = $c.closest("[data-array] > *");
        $c.val($element.attr("data-variant"));
        var oldval = $c.val();
        $c.on("change", function () {
            var newval = $c.val();
            if (newval != oldval) {
                if (!$form.Writing) $form.ChangeVariant($element, newval);
                oldval = newval;
            }
        });
    }

    function setFocus($cont, nx, ny) {
        var $cell = $($($cont.children()[ny]).children()[nx]);
        if ($cell.is("[contenteditable=true]")) {
            $cell.focus().selectText();
        }
        else {
            var $c = $cell.find(":input,[contenteditable=true]").first();
            if ($c.is(":input"))
                $c.focus().select();
            else $c.focus().selectText();;
        }
    }
    function AttachGridPaste($t, $form) {
        $t.attr("tabindex", "0");
        $t.on("paste", function (e) {
            var $cell = $t.find("[data-func=\"grid\"] tr").last().find("select:not([readonly]),:input:not([readonly]),[contenteditable]").closest("td,th").first();
            return pasteToCell(e, $cell);
        });
    }
    function pasteToCell(e, $cell) {
        var text = "";
        if (e.clipboardData || e.originalEvent.clipboardData) {
            text = (e.originalEvent || e).clipboardData.getData("text/plain");
        }
        else if (window.clipboardData) {
            text = window.clipboardData.getData("Text");
        }

        //var $cell = $h.is("td,th") ? $h : $h.closest("td,th");
        var $row = $cell.parent();

        var $container = $row.parent();
        var rows = $container.children(":not(.nogrid)"); // Look up as we go, may be auto increased

        var sx = $cell.index();
        var sy = rows.index($row);

        var x = sx;
        var y = sy;

        var lines = text.split(/\r?\n/);

        if (lines.length == 1) return true;
        //console.log("multiline paste", $cell, sx, sy);
        lines.forEach(function (line) {
            //console.log("row", y);
            var rows = $container.children(":not(.nogrid)"); // Look up as we go, may be auto increased
            if (y >= rows.length) return;
            $row = $(rows[y]);
            var cells = line.split("\t");
            x = sx; // start position (kolonne)
            var $cells = $row.children();
            cells.forEach(function (cell) {
                //console.log("cell", x);

                if (x >= $cells.length) return false;
                $cell = $($cells[x]);
                var $input = $cell.find("select:not([readonly]),:input:not([readonly]),[contenteditable]");
                if ($cell.is("[contenteditable]")) $input = $cell;

                if ($input.length > 0) {
                    $input = $input.first();
                    if ($input.is("select")) {
                        $.each($input.find("option"), function () {
                            var val = $(this).attr("value");
                            if (!val) val = $(this).text();
                            if ($(this).text().toLowerCase().startsWith(cell.toLowerCase())) {
                                $input.val(val).trigger("change").focus();
                                return false;
                            }
                        });
                    }
                    else if ($input.is(":input"))
                        $input.val(cell).trigger("change").trigger("input").focus();
                    else if ($input.is("[contenteditable]"))
                        $input.text(cell).trigger("change").trigger("input").focus();
                    else if ($cell.is("[contenteditable]"))
                        $cell.text(cell).trigger("change").trigger("input").focus();
                }
                x++;
            });
            y++;
        });
        return false;
    }
    function AttachGrid($t, $form) {
        $t.on("nextrow", function () {
            var $c = $t.find(":focus").closest("td,th");
            var nx = $c.index();
            var y = $c.parent().index();
            var ny = y + 1;  // Move to next row
            var $cont = $c.parent().parent();

            if (ny > $cont.children().length - 1) ny = y;

            if (ny != y) {
                setFocus($cont, nx, ny);
                return false;
            }
        });

        $t.on("nextcol", function () {
            var $c = $t.find(":focus").closest("td,th");
            var x = $c.index();
            var $row = $c.parent();
            var y = $row.index();
            var nx = x + 1;  // Move to next column
            var $cont = $row.parent();

            if (nx > $row.children().length - 1) nx = x;

            if (nx != x) {
                setFocus($cont, nx, ny);
                return false;
            }
        });

        $t.on("keydown", function (e) {
            if (e.shiftKey || e.ctrlKey || e.altKey) return true;

            var $c = $t.find(":focus").closest("td,th");
            var x = $c.index();
            var y = $c.parent().index();
            var nx = x;
            var ny = y;
            var $cont = $c.parent().parent();


            var empty = true;
            var $cur = $t.find(":focus");
            var curvalue = "";
            if ($cur.is(":input")) curvalue = $cur.val();
            else curvalue = $cur.text();

            empty = curvalue == "";
            var allSelected = getSelectionText() == curvalue;

            switch (e.which) {
                case 37: // left
                    if (!allSelected && !empty) return true; // abort cell move
                    nx = x - 1;
                    break;
                case 38: // up
                    if (!allSelected && !empty) return true; // abort cell move
                    ny = y - 1;
                    break;
                case 39: // right
                    if (!allSelected && !empty) return true; // abort cell move
                    nx = x + 1;
                    break;
                case 40: // down
                    if (!allSelected && !empty) return true; // abort cell move
                    ny = y + 1;
                    break;
                default:
                    return;
            }
            if (nx < 0) nx = 0;
            if (ny < 0) ny = 0;
            if (ny > $cont.children().length - 1) ny = y;
            if (nx > $c.parent().children().length - 1) nx = x;

            if (nx != x || ny != y) {
                setFocus($cont, nx, ny);
                return false;
            }
        });

        $t.on("paste", "td,th", function (e) {
            var $cell = $t.find(":focus").closest("th,td"); // $(this);
            return pasteToCell(e, $cell);
        });

    };
    function getSelectionText() {
        var text = "";
        if (window.getSelection) {
            text = window.getSelection().toString();
        } else if (document.selection && document.selection.type != "Control") {
            text = document.selection.createRange().text;
        }
        return text;
    }
    jQuery.fn.selectText = function () {
        var doc = document;
        var element = this[0];
        //console.log(this, element);
        if (doc.body.createTextRange) {
            var range = document.body.createTextRange();
            range.moveToElementText(element);
            range.select();
        } else if (window.getSelection) {
            var selection = window.getSelection();
            var range = document.createRange();
            range.selectNodeContents(element);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    };

    function AttachFuncs($t, $form) {
        $t.find("[data-action],[data-func]").addBack("[data-action],[data-func]").each(function () {
            var $c = $(this);
            if ($c.data("attached") == "1") return;
            $c.data("attached", "1");

            var action;
            if ($c.is("[data-action]")) {
                action = $c.attr("data-action");
                $c.attr("formnovalidate", "formnovalidate");
            } else {
                action = $c.attr("data-func");
            }

            //var func = $c.attr("data-func");
            switch (action) {
                // Data actions
                case "sort":
                    AttachSort($c, $form);
                    return;

                case "grid":
                    AttachGrid($c, $form);
                    return;

                case "gridpaste":
                    AttachGridPaste($c, $form);
                    return;

                case "variant":
                    AttachVariant($c, $form);
                    return;

                case "add":
                    AttachAdd($c, $form);
                    return;

                case "link":
                    AttachLink($c, $form);
                    return;

                case "remove":
                case "delete":
                    AttachRemove($c, $form);
                    return;

                case "clone":
                case "copy":
                    AttachClone($c, $form);
                    return;

                case "connect":
                    AttachConnect($c, $form);
                    return;

                // Data funcs
                case "focus":
                    AttachFocus($c, $form);
                    return;

                case "gps":
                    AttachGps($c, $form);
                    return;

                case "popoverbar":
                    AttachPopoverBar($c, $form);
                    return;

                case "input":
                    AttachInput($c, $form);
                    return;

                case "file":
                    AttachFile($c, $form);
                    return;

                case "camera":
                    AttachCamera($c, $form);
                    return;

                case "pasteimg":
                    AttachPasteImg($c, $form);
                    return;

                case "sketch":
                    AttachSketch($c, $form);
                    return;

                case "radio":
                    AttachRadio($c, $form);
                    return;

                case "autogrow":
                    $c.autogrow();
                    return;

                case "collapse":
                    AttachCollapse($c, $form);
                    return;

                case "guid":
                    $c.val(guid());
                    return;

                case "bind":
                case "reqvalidate":
                    // Don't attach anything, is executed by Validate() and Sync();
                    return;

                case "template":
                    // Already handled, dont show error msg
                    return;

                default:
                    $form.trigger("func", [$c, $form]);
                    break;

            }
            $form.Log("Smartform.JS: Unknown data-action/func '" + action + "'");
        });

        $t.find("[data-remove=\"1\"]").each(function () {
            var $c = $(this);
            //if ($c.attr("data-remove") != null) {
            $c.children().not("[data-noarray],.autoinsert").remove();
            if ($c.children().length == 0) $c.html(""); // Clear all content to make placeholders work
            //}
        });
    };
    function AttachFocus($t, $form) {
        $t.on("click", function (e) {
            if (e.target == $t[0])
                $form.FocusElement($t);
        });
    };

    var popoverlock = null;
    function AttachGps($t, $form) {
        var n = $t.attr("data-name");
        if (n == null || n == "") {
            $form.Log("Invalid GPS field in form, missing data-name attribute");
            return;
        }
        var icon = $t.attr("data-glyphicon");
        if (icon == null || icon == "") icon = "map-marker";

        if (icon != "none") {
            var $s = $("<span/>");
            $s.attr("class", "glyphicon glyphicon-" + icon);
            $t.append($s);
        }
        var $input = $("<input type=\"hidden\" name=\"" + n + "\" />");
        $t.append($input);
        $input.on("change", function () {
            if ($input.val() != "") {
                $t.addClass("active");
            } else {
                $t.removeClass("active");
            }
        });

        $t.on("click", function () {
            // Store position
            if (navigator.geolocation) {

                if ($input.val() == "") {
                    navigator.geolocation.getCurrentPosition(function (pos) {
                        $t.addClass("active");
                        $input.val(pos.coords.latitude + ":" + pos.coords.longitude).trigger("change");
                    });
                } else {
                    $t.removeClass("active");
                    $input.val("").trigger("change");
                }
            } else {
                $.fn.Alert("Geolocation is not supported by this browser!");
                //x.innerHTML = "Geolocation is not supported by this browser.";
            }
        });
    };
    function AttachPopoverBar($t, $form) {
        $t.hide();
        var $tb = $form.find("[data-name=\"" + $t.attr("data-target") + "\"]");
        var $props = $tb.find(".addprops");
        var $element = $t.closest("[data-array] > *");
        if ($element.length == 0) $element = $form;
        var $posby = $element;
        var $attachto = $element;

        var container = $t.attr("data-container");
        if (container != null) {
            $posby = $t.closest(container);
        }

        var attachto = $t.attr("data-attachto");
        if (attachto != null) {
            $attachto = $t.closest(attachto);
        }

        var mypos = "center top";
        var atpos = "center bottom";
        var pos = $t.attr("data-placement");
        if (pos != null && pos != "") {
            switch (pos.toLowerCase()) {
                case "top":
                    mypos = "center bottom";
                    atpos = "center top";
                    break;

                case "right":
                    mypos = "left center";
                    atpos = "right center";
                    break;

                case "left":
                    mypos = "right center";
                    atpos = "left center";
                    break;

                default:
                    pos = "bottom";
            }
        } else {
            pos = "bottom";
        }

        function lockToElement() {
            if (popoverlock != null) {
                clearTimeout(popoverlock);
                popoverlock = null;
            }
            if (!$tb.is(":visible") || !$element.is(":visible")) {
                // Properties dialog quit, move fields back
                $tb.hide();
                //$props.html("");
                return;
            }

            if (!$tb.is("." + pos)) {
                $tb.removeClass("top bottom left right");
                $tb.addClass(pos);
            }

            $tb.position({
                my: mypos,
                at: atpos,
                of: $tb.data("lockto"),
                collision: "fit none"
            });

            popoverlock = setTimeout(function () {
                lockToElement();
            }, 50);
        }

        $attachto.on("depopover", function () {
            clearTimeout(popoverlock);
            $tb.hide();

            // Move fields back to previously selected element
            var p = $props.data("parent");
            if (typeof p !== "undefined") {
                p.append($props.children());
                $props.removeData("parent");
            }
        });

        $attachto.on("popover", function () {
            // Move fields back to previously selected element
            var p = $props.data("parent");
            if (typeof p !== "undefined")
                p.append($props.children());

            // Attach general command buttons to selected element
            $tb.find("[data-func],[data-action]").each(function () {
                $(this).data("array-target", $element);
            });

            // Add form fields for selected element
            $props.data("parent", $t);
            $props.append($t.children());



            // Show and position toolbar
            $tb.data("lockto", $posby);
            lockToElement(); // Prepare before show
            $tb.show();
            lockToElement(); // Ensure position

            if ($form.HasMouse)
                $form.FocusElement($tb); //Focus first child
            return false;
        });



        if ($tb.data("tbinited") != true) {
            $tb.find(".close").on("click touchstart mousedown", function () {
                $tb.hide();
            });
            $tb.data("tbinited", true);
        }

    };
    $.fn.HookActions = function ($form) {
        var $t = $(this);

        AttachArrays($t, $form);
        AttachFuncs($t, $form);

        $form.UpdateCalculations();

        if (typeof AttachDocEvents == "function") {
            AttachDocEvents($t, $form); // TODO: Phase this option out, use events instead.
        }
        $form.trigger("attachevents", [$t, $form]); // Obsolete!
        $t.trigger("attach", [$t, $form]);
        if ($form.$placeholder) {
            // $form is detached, trigger event in DOM as well
            $form.$placeholder.trigger("attach", [$t, $form]);
        }

        CopyLast($t, $form);
    };

    function CopyLast($e, $form) {
        var $copyList = $e.find("[data-copyprevious]");
        $copyList.on("modify change", function () {
            $(this).removeAttr("data-copyprevious");
        });

        if ($form.Writing) return; // Only copy values at user input
        var $parent = $e.parent();

        if ($copyList.length == 0) return; // No fields marked with copyprevious
        if ($parent.attr("data-array") == null) return;

        var $items = $e.parent().children();
        var autoinsert = 0;
        if ($e.parent().attr("data-autoinsert") != null) autoinsert = 1; // If autoinsert is enabled shift one row up when reading + writing data

        if ($items.length > (1 + autoinsert) && !$form.Writing) { // Check that this is not the first row
            var $prevRow = $($items[$items.length - 2 - autoinsert]); // Get previous row
            var $newRow = $($items[$items.length - 1 - autoinsert]); // Get previous row

            var newData = {};
            var prevData = $form.Read($prevRow);

            $.each($newRow.find("[data-copyprevious]"), function () {
                var fieldname = $(this).attr("name") || $(this).attr("data-name");
                newData[fieldname] = prevData[fieldname];
            });
            $form.WriteSection($newRow, newData);
        }
    }

    $.fn.SmartformTexts = {
        Sketchpad: {
            Title: "Sketchpad",
            OKBtn: "OK",
            CancelBtn: "Avbryt"
        },
        Image: {
            TypeError: "Only image files are allowed in this field!",
            LoadError: "Image load error!"
        },
        PasteImg: {
            ToolTipTitle: "Lim inn bilde",
            ToolTipText: "Kopier &oslash;nsket bilde til utklippstavle og trykk CTRL+V her"
        },
        ImgToolMenu: {
            ResetImg: "Fjern",
            DownloadImg: "Last ned",
            ViewImg: "Vis bildet"
        },
        DocNotes: {
            DefaultNoteText: "Legg inn notattekst her,\r\ndra og slipp for &aring; plassere..."
        },
        Actions: {
            ConfirmDeleteRow: "Vil du slette valgt rad?<small> - Det ser ut til at raden kan inneholde informasjon som vil bli mistet</small>",
            SortToolTip: "Dra og slipp for &aring; sortere"
        },
        Validation: {
            ErrorTitle: "Validation error"
        }
    };


    $.fn.autogrow = function () {
        var $self = $(this);
        var textarea = $self[0];

        $self.updateSize = function (event) {
            var sy = $(window).scrollTop();
            textarea.style.height = "0";
            textarea.style.height = (textarea.scrollHeight + 15) + "px";
            $(window).scrollTop(sy);
        };

        $self.on("change input keyup keydown autogrow", $self.updateSize);
        $(window).resize($self.updateSize);

        $self.updateSize();
    };
    /* */
})(jQuery);

// Created by STRd6
// MIT License
// jquery.paste_image_reader.js
(function ($) {
    var defaults;
    $.event.fix = (function (originalFix) {
        return function (event) {
            event = originalFix.apply(this, arguments);
            if (event.type.indexOf("copy") === 0 || event.type.indexOf("paste") === 0) {
                event.clipboardData = event.originalEvent.clipboardData;
            }
            return event;
        };
    })($.event.fix);
    defaults = {
        callback: $.noop,
        matchType: /image.*/
    };
    return $.fn.pasteImageReader = function (options) {
        if (typeof options === "function") {
            options = {
                callback: options
            };
        }
        options = $.extend({}, defaults, options);
        return this.each(function () {
            var element = this;
            var $this = $(this);
            return $this.bind("paste", function (event) {
                var found = false;
                var clipboardData = event.clipboardData;
                var types = clipboardData.types;
                return Array.prototype.forEach.call(clipboardData.types, function (type, i) {
                    if (found) return null;

                    if (type.match(options.matchType) || clipboardData.items[i].type.match(options.matchType)) {
                        $(".loading").show().fadeIn(1).removeClass("hide");
                        var item = clipboardData.items[i];
                        var file = item.getAsFile();

                        setTimeout(function () {
                            var reader = new FileReader();
                            reader.onload = function (evt) {
                                $(".loading").stop(true, true).fadeOut(10);
                                var result = options.callback.call(element, {
                                    dataURL: evt.target.result,
                                    event: evt,
                                    file: file,
                                    name: file.name,
                                    types: types
                                });

                                return result;
                            };
                            reader.readAsDataURL(file);
                        }, 0);

                        return found = true;
                    }
                    return null;
                });
            });
        });
    };
})(jQuery);